class comprehensiveinfo {
  constructor(data) {
    // const price = data.desc;
    console.log("This is my date", data);
    this.items = {
      id: 30001,
      name: "Additional Cover",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [],
      backtostart: true,
      text: [
        `<p>Thank you! We are now preparing your car insurance policy. Inspection of your vehicle is the mandatory
        process. We will connect you soon.</p>`,
        `<p>Congratulation! Your car insurance cover note is now ready.</p>`,
        `<p>Please provide your email address so we can share the details of the insurance policy you’ve purchased.</p>`,

        //   `<p><a href="https://www.example.com" target="_blank">Click here</a>.</p>`,
        //   `<p>Please provide feedback to improve our services</p> `,
      ],
    };
    const convertBase64ToFile = (base64String, filename) => {
      const arr = base64String.split(",");
      const mimeMatch = arr[0].match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : "image/png";

      const bstr = atob(arr[1]); // decode base64
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    };
    const attachments = JSON.parse(
      sessionStorage.getItem("attachments") || "[]"
    );
    console.log("attchements", attachments);
    const files = attachments
      .filter((item) => item.image)
      .map((item) => ({
        flag: item.flag,
        file: convertBase64ToFile(item.image, `${item.flag}.png`),
      }));
    console.log(files);

    // Retrieve car information from sessionStorage
    const carInformation = JSON.parse(
      sessionStorage.getItem("car_information")
    );
    const user = JSON.parse(sessionStorage.getItem("user"));
    const policy_id = JSON.parse(sessionStorage.getItem("policy_id"));
    if (carInformation && user) {
      this.carInformation = {
        id: policy_id,
        userMsisdn: user.userMsisdn,
        ...(files.length > 0 && { car_pictures: files }),
        applicationUserId: user.applicationUserId,
        ...carInformation.reduce((acc, item) => {
          acc[item.key] = item.value;
          return acc;
        }, {}),
        status: "Active",
      };
    }
    const formData = new FormData();
    this.formData = formData;

    for (const key in this.carInformation) {
      const value = this.carInformation[key];
      console.log(value);
      if (key === "car_pictures" && Array.isArray(value)) {
        value.forEach((item, index) => {
          this.formData.append(`car_pictures[${index}]`, item.file); // ✅ match backend's car_pictures[0]
        });
      } else if (
        typeof value === "object" &&
        value !== null &&
        !(value instanceof File)
      ) {
        formData.append(key, JSON.stringify(value)); // stringify nested objects
      } else {
        formData.append(key, value);
      }
    }
  }

  async getAllItems() {
    const savedItems = await this.saveToAPI();
    return savedItems;
  }

  getFaildOptions() {
    return [
      {
        id: 40012,
        text: "Buy Now",
        name: "Buy Now",
        price: "",
        type: "paymentoptions",
        desc: "Buy Now",
        inputtype: "button",
      },
    ];
  }

  getSuccessOptions() {
    return [
      {
        id: 40012,
        text: "Excellent",
        name: "Excellent 🙂",
        price: "",
        type: "isexcellent",
        desc: "Excellent 🙂",
      },
      {
        id: 40012,
        text: "Good",
        name: "Satisfactory 😐",
        price: "",
        type: "isgood",
        desc: "Satisfactory 😐",
      },
      {
        id: 40012,
        text: "Bad",
        name: "Unsatisfactory 🙁",
        price: "",
        type: "isbad",
        desc: "Unsatisfactory 🙁",
      },
    ];
  }

  async saveToAPI() {
    try {
      console.log("car information =");
      const response = await fetch(
        "https://Digital.webdoc.com.pk/Promotion/public/api/v1/chat/car-insurance/update-policy",
        {
          method: "POST",
          body: this.formData,
        }
      );
      console.log("response =>", response);
      if (response.ok) {
        // console.log("Data saved successfully", this.getSuccessOptions());
        const result = await response.json();
        console.log("result =>", result);

        const baseUrl = window.location.origin;
        this.items.text = [
          `<p>Thank you! We are now preparing your car insurance policy. Inspection of your vehicle is the mandatory
        process. We will connect you soon.</p>`,
          `<p>Congratulation! Your car insurance cover note is now ready.</p>`,
          `Please provide your email address so we can share the details of the insurance policy you’ve purchased.`,
          // `<p><a href="${baseUrl}/car-insurance-policy-paper/1" target="_blank">Click here</a>.</p>`,
          // `<p>Please provide feedback to improve our services</p> `,
        ];
        this.items.issuccess = true;
        if (this.insType === "thirdparty") {
          this.items.options = this.getFaildOptions();
        } else {
          this.items.options = [
            {
              id: result?.payLoad.id,
              text: "Submit",
              name: "New Policy",
              type: "policy",
              desc: this.items.desc,
              inputtype: "textinput",
            },
          ];
        }
        return this.items;
      } else {
        this.items.text = ["Failed to save data."];
        this.items.issuccess = false;
        if (this.insType === "thirdparty") {
          this.items.options = this.getFaildOptions();
        } else {
          this.items.options = [
            {
              id: 40012,
              text: "Confirm",
              name: "Confirm",
              price: "",
              type: "providecnic",
              desc: "Confirm",
              inputtype: "button",
              key: "car_color",
            },
          ];
        }
        return this.items;
      }
    } catch (error) {
      console.error("Error saving data:", error);
      this.items.text = ["Failed to save policy."];
      this.items.issuccess = false;
      if (this.insType === "thirdparty") {
        this.items.options = this.getFaildOptions();
      }
      this.items.options = [
        {
          id: 40012,
          text: "Confirm",
          name: "Confirm",
          price: "",
          type: "providecnic",
          desc: "Confirm",
          inputtype: "button",
          key: "car_color",
        },
      ];
      return this.items;
    }
  }
}

export default comprehensiveinfo;
